import {
    SuperBit_swaggerClient,
    FilterDataModel,
    RiderPackageModel,
} from './superbit-api-models';
import generalSettings from '../json/general-settings.json';

// Service wrapper for the System Management "Rider packages" tab.
// Replaces the old MVC Views/SystemManagement/Riders/_RiderPackages.cshtml view
// (+ _RiderPackagesItems.cshtml and _NewRiderPackage.cshtml) and the
// RiderController3 endpoints the old systemManagement.js posted to
// (riderSortPackage / riderGetPackage / riderUpsertPackage / riderDeletePackage
// / riderUpdateIncludeInPolicyPrice / riderUpdateSideGimel / riderUpdatePrivateIncome).
export class RidersModel {
    client: any;

    constructor() {
        const apiUrl = localStorage.getItem('apiUrl');
        const url = apiUrl ? apiUrl : generalSettings.apiUrl;

        // Some generated client methods omit the Authorization header; inject it
        // here (only when absent) so every call through this client is authenticated.
        // Same shim BranchesModel uses.
        const authHttp = {
            fetch(input: RequestInfo, init?: RequestInit) {
                const token = localStorage.getItem('AuthToken');
                const headers: any = { ...(init && init.headers ? init.headers : {}) };
                if (token && !headers['Authorization']) {
                    headers['Authorization'] = `Bearer ${token}`;
                }
                return window.fetch(input, { ...(init || {}), headers });
            },
        };

        this.client = new SuperBit_swaggerClient(url, authHttp);
    }

    // Sorted/filtered list of rider packages (replaces _RiderPackagesItems.cshtml).
    // The server sorts by Name and applies the optional SearchTerm; it does NOT
    // paginate, so the whole list comes back in one call.
    async sortPackages(filter: FilterDataModel): Promise<RiderPackageModel[]> {
        const res = await this.client.riderSortPackage(filter);
        return res ? res : [];
    }

    // Loads a package for editing (id set) OR a fresh package for adding (id
    // undefined). Either way the returned model carries the lookups the add/edit
    // form binds to: AllServices, AllSuppliers, AllCompanies, VehicleDetails
    // (the manufacturer tree) and VehicleOwnershipList.
    async getPackage(id?: string): Promise<RiderPackageModel> {
        return await this.client.riderGetPackage(id);
    }

    // Create AND edit both post through riderUpsertPackage (the server upserts by
    // Id), mirroring the old form which always posted to Rider/UpsertPackage.
    async upsertPackage(model: RiderPackageModel): Promise<void> {
        return await this.client.riderUpsertPackage(model);
    }

    async deletePackage(id: string): Promise<void> {
        return await this.client.riderDeletePackage(id);
    }

    // The grid's inline "include in policy price" checkbox toggle. The server
    // updates only that flag for the given package id.
    async updateIncludeInPolicyPrice(model: RiderPackageModel): Promise<void> {
        return await this.client.riderUpdateIncludeInPolicyPrice(model);
    }

    async updateSideGimel(model: RiderPackageModel): Promise<void> {
        return await this.client.riderUpdateSideGimel(model);
    }

    async updatePrivateIncome(model: RiderPackageModel): Promise<void> {
        return await this.client.riderUpdatePrivateIncome(model);
    }
}
